import { put, call, fork, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import { recoveryEmailRequest } from 'requesters/recoveryEmailRequester';
import { recoveryEmailSuccess, recoveryEmailFailure } from 'actions/passwordRecoveryActions';
import { RECOVERY_EMAIL_REQUEST } from 'constants/actionTypes';
import { push } from 'react-router-redux';

/**
 * Password Recovery Email API call.
 * On success, dispatch recoveryEmailSuccess
 * On failure, dispatch recoveryEmailFailure with the response error code
 * @param {String} email
 * @return {void}
 */
export function *requestRecoveryEmail(email) {
  try {
    yield call(recoveryEmailRequest, email);
    yield put(push('/recovery_email_sent'));
    yield put(recoveryEmailSuccess());
  } catch (error) {
    const errorNumber = parseInt(error.message, 10);
    if (errorNumber >= 400 && errorNumber < 500) {
      yield put(recoveryEmailFailure('emailNotFound'));
    } else {
      yield put(recoveryEmailFailure('serverError'));
    }
  }
}

export function *processRecoveryEmail() {
  const state = yield select();
  yield call(requestRecoveryEmail, state.passwordRecovery.email);
}

/**
 * Waits for the return of the RECOVERY_EMAIL_REQUEST action event, pulls email
 * from appState, and calls the requestRecoveryEmail saga
 * @return {void}
 */
export function *recoveryEmailWatcher() {
  yield* takeEvery(RECOVERY_EMAIL_REQUEST, processRecoveryEmail);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(recoveryEmailWatcher);
}
